import React from 'react';
import SubscriptionTemplate from './SubscriptionTemplate';
import { displayMessage } from './wsHelpers';
import { connect } from 'react-redux';
import { updateMedia, deleteMedia } from '@/redux/actions';
import { useParams } from 'react-router-dom';

const WS_MEDIA_BY_HTTP = {
	DELETE: 'media/:mediaID/DELETE',
	UPDATE: 'media/:mediaID/PATCH',
};

const MediaSubscriptions = props => {
	const { socket, updateMedia, deleteMedia } = props;
	const { id: mediaID } = useParams();
	const propsToSend = { ...props };
	delete propsToSend.children;

	const subscribe = () => {
		socket.emit('media/:mediaID/SUBSCRIBE', { mediaID });
	};

	const unsubscribe = () => {
		socket.emit('media/:mediaID/UNSUBSCRIBE', { mediaID });
	};

	const listenForUpdatedMedia = () => {
		socket.on(WS_MEDIA_BY_HTTP.UPDATE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Error updating media', error);
			else {
				const { name } = data;
				updateMedia(data);
				displayMessage(`${name} succesfully updated`);
			}
		});
	};

	const listenForDeletedMedia = () => {
		socket.on(WS_MEDIA_BY_HTTP.DELETE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Error deleting media', error);
			else {
				deleteMedia(data);
				const { mediaName } = data;
				displayMessage(`${mediaName} deleted`);
				window.history.back();
			}
		});
	};

	const listeners = () => [listenForDeletedMedia, listenForUpdatedMedia];

	return (
		<>
			<SubscriptionTemplate
				{...props}
				sub={subscribe}
				unsub={unsubscribe}
				listeners={listeners()}
				routes={Object.values(WS_MEDIA_BY_HTTP)}
				from="MediaSubscriptions"
			/>
			{React.cloneElement(props.children, propsToSend)}
		</>
	);
};

const msp = ({ ws, auth, events, eventMedia }) => ({
	socket: ws.socket,
	auth0Token: auth.auth0Token,
	currentEventId: events.currentEvent.id,
	eventMedia,
});

const mdp = dispatch => ({
	updateMedia: media => dispatch(updateMedia(media)),
	deleteMedia: mediaID => dispatch(deleteMedia(mediaID)),
});

export default connect(msp, mdp)(MediaSubscriptions);
